export default __webpack_public_path__ + "static/media/blog-post-layout-04-img-12.ee0a1a45.jpg";